/* eslint-disable react/display-name */
import React from "react";
import PropTypes from "prop-types";
import matchSorter from "match-sorter";
import isEmpty from "lodash/isEmpty";
import ReactTable from "react-table";
import { PhoneNumber as phoneNumber } from "../../../helpers";
import Loading from "../../common/Loading";
import ResponsiveDataComponent from "../../common/ResponsiveDataComponent";
import TableActions from "../../common/TableActions";

const ContactList = ({
  customer,
  search,
  onClickView,
  onClickDelete,
  isMobile,
  minimal
}) => {
  const columns = !isMobile
    ? [
        { Header: "First", accessor: "first_name" },
        { Header: "Last", accessor: "last_name" },
        { Header: "Title", accessor: "title" },
        { Header: "Email", accessor: "email" },
        {
          Header: "Phone",
          accessor: "business_phone",
          Cell: (row) => phoneNumber(row.value)
        },
        { Header: "Ext.", accessor: "business_phone_ext", maxWidth: 67 }
      ]
    : [
        { Header: "First", accessor: "first_name" },
        { Header: "Last", accessor: "last_name" }
      ];

  columns.push({
    accessor: "_id",
    maxWidth: 80,
    sortable: false,
    Cell: (row) => (
      <TableActions
        onClickView={() => onClickView(row.value)}
        onClickDelete={() => onClickDelete(row.value)}
      />
    )
  });

  let { contacts } = customer;

  if (search) {
    contacts = matchSorter(contacts, search, {
      keys: [
        "first_name",
        "last_name",
        "customer.name",
        "title",
        "email",
        "businesss_phone",
        "business_phone_ext"
      ]
    });
  }

  const props = {
    getTdProps: (state, rowInfo, column) => {
      if (!column.expander && rowInfo?.original?._id) {
        return {
          onClick: () => {
            if (column.id !== "_id") {
              onClickView(rowInfo.original._id);
            }
          }
        };
      }
      return {};
    }
  };

  const isLoading = !isEmpty(customer) && contacts && !contacts.length;
  contacts = contacts || [];

  return (
    <ReactTable
      className="-highlight"
      data={contacts}
      columns={columns}
      defaultPageSize={10}
      showPagination={!minimal}
      noDataText="No contacts found"
      pageSize={minimal ? contacts.length + 1 : 10}
      LoadingComponent={() => <Loading active={isLoading} timeout={1000} />}
      {...props}
      SubComponent={
        isMobile
          ? (row) => (
              <ResponsiveDataComponent
                data={[
                  { key: "First Name", label: row.original.first_name },
                  { key: "Last Name", label: row.original.last_name },
                  { key: "Customer", label: row.original.customer.name },
                  { key: "Title", label: row.original.title },
                  { key: "Email", label: row.original.email },
                  {
                    key: "Phone",
                    label: phoneNumber(row.original.business_phone)
                  },
                  {
                    key: "Ext.",
                    label: phoneNumber(row.original.business_phone_ext)
                  }
                ]}
              />
            )
          : false
      }
    />
  );
};

ContactList.propTypes = {
  onClickDelete: PropTypes.func.isRequired,
  filter: PropTypes.object,
  onChange: PropTypes.func,
  customer: PropTypes.object,
  search: PropTypes.string,
  onClickView: PropTypes.func,
  isMobile: PropTypes.bool,
  minimal: PropTypes.bool
};

export default ContactList;
